import { Button } from "@/components/ui/button";
import { Check, CreditCard, Crown, Loader2, Sparkles, Zap } from "lucide-react";

export function SocialAgentPricing({ plans, saving, onSubscribe, onActivateTrial }) {
  return (
    <div className="max-w-5xl mx-auto space-y-8" data-testid="social-agent-pricing">
      <div className="text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-pink-100 text-pink-700 text-sm font-medium mb-4">
          <Sparkles className="w-4 h-4" /> Marketplace
        </div>
        <h1 className="text-3xl sm:text-4xl font-black">
          <span className="bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent">
            Kaiso Social Agent
          </span>
        </h1>
        <p className="text-muted-foreground mt-2 max-w-xl mx-auto">
          Automatize suas redes sociais com IA. Posts automáticos, anúncios inteligentes e muito mais.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-5">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`relative bg-white border-2 rounded-2xl p-6 transition-all hover:shadow-lg ${
              plan.id === "premium" ? "border-purple-500 shadow-purple-100" : "border-gray-200"
            }`}
            data-testid={`plan-${plan.id}`}
          >
            {plan.id === "premium" && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-purple-600 text-white text-xs font-bold rounded-full flex items-center gap-1">
                <Crown className="w-3 h-3" /> MAIS POPULAR
              </div>
            )}
            <div className="text-center mb-4">
              <h3 className="text-lg font-bold">{plan.name}</h3>
              <div className="mt-2">
                <span className="text-3xl font-black">{plan.currency_symbol || "€"}{plan.price.toFixed(2)}</span>
                <span className="text-muted-foreground text-sm">/mês</span>
              </div>
            </div>
            <ul className="space-y-2 mb-6">
              {plan.features.map((feature, idx) => (
                <li key={idx} className="flex items-start gap-2 text-sm">
                  <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            <Button
              onClick={() => onSubscribe(plan.id)}
              disabled={saving}
              className={`w-full ${
                plan.id === "premium"
                  ? "bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700"
                  : "bg-gray-900 hover:bg-gray-800"
              }`}
              data-testid={`subscribe-${plan.id}`}
            >
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4 mr-2" />}
              Assinar Agora
            </Button>
          </div>
        ))}
      </div>

      <div className="text-center bg-gradient-to-r from-pink-50 to-purple-50 rounded-2xl p-6">
        <p className="text-sm text-muted-foreground mb-3">
          Ainda não tem certeza? Experimente grátis por 7 dias!
        </p>
        <Button
          variant="outline"
          onClick={onActivateTrial}
          disabled={saving}
          className="border-pink-300 text-pink-700 hover:bg-pink-50"
          data-testid="activate-trial-btn"
        >
          <Zap className="w-4 h-4 mr-2" />
          Ativar Trial Grátis
        </Button>
      </div>
    </div>
  );
}
